import { CapoPlugin } from "/app/node_modules/.pnpm/@unhead+vue@1.11.2_vue@3.5.4/node_modules/@unhead/vue/dist/index.mjs";
export default import.meta.server ? [CapoPlugin({ track: true })] : [];